import React from "react";
import ReactDOM from "react-dom";
import "./styles/scss/main.css";
import "./styles/tailwind.css";
import "./styles/calendar.css";
import App from "./routes/App";
import Modal from "react-modal";

import reportWebVitals from "./reportWebVitals";
import StoreProvider from "./global/StoreProvider";
import { initInterceptors } from "./services/refresh";

Modal.setAppElement("#root");
initInterceptors();

ReactDOM.render(
  <React.StrictMode>
    <StoreProvider>
      <App />
    </StoreProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
